import Logger from "@cappelendamm/logger";
import { AddressSchema } from "../schemas/address-schema.js";
export const getValidatedAddress = (address) => {
    let validatedAddress;
    try {
        validatedAddress = AddressSchema.parse(address);
    }
    catch (error) {
        Logger.error(`Failed to validate address with customer address phone: ${address.phone}. Error: ${error}`);
        return undefined;
    }
    return validatedAddress;
};
